'use strict';
import { ChangePasswordBase } from './ChangePasswordBase';
import Render from './ChangePasswordRender';
import { connect } from 'react-redux';

class ChangePassword extends ChangePasswordBase {
    render() {
        return Render.call(this, this.props, this.state);
    }
}

export default ChangePassword = connect((state)=>{
    return {user:state.user || {}}
})(ChangePassword);